import React from 'react';
import { Modal } from '../Modal';
import Button from '../Button/Button';
import './InformationModal.scss';
import InformationCard from '../informationCard/InformationCard';

interface IModalTypes {
  onConfirmClick: () => void;
  onClose: () => void;
  isOpen?: boolean;
  title?: string;
  message?: string;
  confirmBtnText: string;
  informationText?: string;
}

const InformationModal = ({
  onConfirmClick,
  isOpen = true,
  title,
  message,
  confirmBtnText,
  onClose,
  informationText,
}: IModalTypes) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="confirmation-modal-container">
        <div className="confirmation-title">{title}</div>
        <div className="confirmation-description">
          <p>{message}</p>
        </div>
        <InformationCard text={informationText} />
        <Button
          label={confirmBtnText}
          styleKey="dark"
          className="confirmation-button"
          onClick={onConfirmClick}
        />
      </div>
    </Modal>
  );
};

export default InformationModal;
